import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../auth/models/IUser';
import { ICustomer } from '../auth/models/ICustomer';
import { UserService } from '../auth/services/user.service';
import { CustomerService } from '../auth/services/customer.service';
import { environment } from '../../environments/environment';
import { StrategiesPermissionsService } from '../strategies/services/strategies-permissions.service';
import { AuthService } from '../auth/services/auth.service';


@Component({
  selector: 'app-left-nav',
  templateUrl: './app-left-nav.component.html',
  styleUrls: ['./app-left-nav.component.scss']
})
export class AppLeftNavComponent implements OnInit {
  user: IUser;
  customer: ICustomer;
  hasAccessToSingleInstitution: boolean;
  canSeeUserMgmtLink: boolean;
  institutionLocation =  {city: '', state: ''};
  privacyPolicyUrl = environment.privacyPolicyUrl;
  @Output() logout = new EventEmitter<any>();
  @Output() hide = new EventEmitter<any>();
  date = new Date();

  constructor(
    private router: Router,
    private userService: UserService,
    private customerService: CustomerService,
    private strategiesPermissionsService: StrategiesPermissionsService,
    private authService: AuthService
  ) { }

  get appVersion() {
    return environment.version.version;
  }

  ngOnInit() {
    this.user = this.userService.user;
    this.hasAccessToSingleInstitution = this.customerService.hasAccessToSingleInstitution;
    this.customer = this.customerService.institution;
    this.canSeeUserMgmtLink = this.strategiesPermissionsService.userInstitutionPermissions.canManageUsers;
    this.populateInstitutionLocation();
  }

  onNavigateToInstitutionSelector() {
    this.router.navigate(['/select-institution']);
  }

  onNavigateToManageUsers() {
    this.hide.emit();
    this.router.navigate(['/manage-users']);
  }

  onNavigateToStrategies() {
    this.hide.emit();
    this.router.navigate([`/strategies/dashboard/${this.customer.id}`]);
  }

  onNavigateToResources() {
    this.hide.emit();
    this.router.navigate(['/resources']);
  }

  onLogout() {
    this.authService.logout();
  }

  private populateInstitutionLocation() {
    this.customerService.getInstitutionMetaData().subscribe(
      (customer: ICustomer) => {
        this.customerService.selectedInstitutionMeta = customer;
        this.institutionLocation = {
          city: customer.addressDTO[0].city,
          state: customer.addressDTO[0].stateDTO.name
        };
      }
    );
  }
}
